module.exports = __webpack_public_path__ + "img/logo@3x.b034f24f.png";